<template>
  <b-modal
    id="airport-companies"
    ref="modal"
    :title="$t('companies.title')"
    :ok-disabled="formOpened"
    :cancel-disabled="formOpened"
    :hide-header-close="formOpened"
    :no-close-on-backdrop="formOpened"
    :no-close-on-esc="formOpened"
    size="lg"
    centered
  >
    <b-card v-if="formOpened" :header="formHeader">
      <companies-form
        :id="editId"
        :airport-id="airportId"
        :api-interface="api"
        @saved="onSaved"
        @cancel="closeForm"
      />
    </b-card>

    <b-button v-if="!formOpened" variant="light" class="mb-2" @click="onAdd">
      {{ $t('general.add_new') }}
    </b-button>

    <companies-table ref="table" :api-builder="apiBuilder" @edit="onEdit" />
  </b-modal>
</template>

<script>
import CompaniesForm from './Form'
import CompaniesTable from './Table'
import Api from './Api'

export default {
  components: {
    CompaniesForm,
    CompaniesTable,
  },

  props: {
    airportId: { type: [Number, String], required: true },
  },

  data: () => ({
    formOpened: false,
    editId: null,
  }),

  computed: {
    formHeader() {
      return this.editId === null
        ? this.$t('general.add_new')
        : this.$t('general.edit')
    },
    api() {
      return new Api(this.airportId)
    },
  },

  methods: {
    apiBuilder() {
      return this.api
    },
    onSaved() {
      this.$refs.table.refresh()
      this.closeForm()
    },
    onUpdated() {
      this.$refs.table.refresh()
    },
    onEdit(item) {
      this.closeForm()
      this.editId = item.id
      this.formOpened = true
    },
    onAdd() {
      this.formOpened = true
      this.editId = null
    },
    closeForm() {
      this.editId = null
      this.formOpened = false
    },
  },
}
</script>
